// ABOUTME: Zod validation schemas and types for Rusada → TechLog defect deferral transformation.
import {
  ZRusadaDefectResponse,
  ZRusadaMelCategoryResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import {
  ZTechlogDefectDeferInput,
  ZTechlogDefectResponse,
} from '../../../../types/techLog/defect.zod';
import { z } from 'zod';

/**
 * Input validation schema for DEFER action (Rusada → TechLog).
 * Requires the Rusada defect (with deferral data) and the TechLog defect (to update).
 * syncLog is required to map between systems - throws if the defect wasn't previously synced.
 */
export const ZRusadaToTechlogDefectDeferInput = z.object({
  rusada: z.object({
    // melPriorityId is nullable in the canonical API response (non-deferred defects may lack it),
    // but required here because deferral mapping depends on it.
    defect: ZRusadaDefectResponse.extend({
      melPriorityId: z
        .number()
        .int()
        .nullable()
        .refine((val) => val !== null && val !== undefined, {
          message:
            'Defect must have a MEL priority assigned before it can be deferred.',
        }),
    }),
    // At least one MEL category must exist to resolve rectificationCategory and limitCalendarDays.
    melCategories: z.array(ZRusadaMelCategoryResponse).min(1),
  }),
  techlog: z.object({
    defect: ZTechlogDefectResponse,
  }),
  syncLog: z.object({
    originEntityId: z.string(),
    destinationEntityId: z.string(),
  }),
});

export const ZRusadaToTechlogDefectDeferOutput = ZTechlogDefectDeferInput;

export type RusadaToTechlogDefectDeferInput = z.infer<
  typeof ZRusadaToTechlogDefectDeferInput
>;
export type RusadaToTechlogDefectDeferOutput = z.infer<
  typeof ZRusadaToTechlogDefectDeferOutput
>;
